import React from "react";
import CommunityAddPage from "../community/components/CommunityAddPage";
import { SHARE_WITH_NEIGHBORS } from "../community/constants";
import { useRequireSectionVisible } from "../../client/hooks/useRequireSectionVisible";

export default function AddShareWithNeighborsPage() {
  useRequireSectionVisible("showShareWithNeighbors");
  return <CommunityAddPage section={SHARE_WITH_NEIGHBORS} />;
}
